import { useState, useEffect, useCallback } from "react";

// We are temporarily pulling recommended maturity data from the video config file
// rather than the metadata endpoint.
// We are not using useRestQuery since internally it uses fetchJson
// that has the credentials parameter "{ credentials: 'include' }", not supported by
// the video config endpoint.
// Since we are temporarily fetching the video config endpoint,
// instead of modifying fetchJson, we are using this hook.
const useGetVideoConfig = (url) => {
  const [videoConfig, setVideoConfig] = useState();

  const getConfig = useCallback(async () => {
    try {
      const res = await fetch(url);
      const config = await res.json();
      setVideoConfig(config);
    } catch (err) {
      console.error(err);
    }
  });

  useEffect(() => {
    getConfig();
  }, []);

  return videoConfig;
};

export default useGetVideoConfig;
